import { render } from "./RejectReason.vue?vue&type=template&id=93d24c24&ts=true"
import script from "./RejectReason.vue?vue&type=script&lang=ts"
export * from "./RejectReason.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__